<ng-container *transloco="let t">
  @if (selectedChannels.length > 0 || selectedUsers.length > 0 || selectedMailAddresses.length > 0) {
    <pxc-receiver-list
      [channels]="selectedChannels"
      [mailAddresses]="selectedMailAddresses"
      [users]="selectedUsers"
      (removeChannel)="removeChannel($event)"
      (removeMailAddress)="removeMailAddress($event)"
      (removeUser)="removeUser($event)" />
  }

  <tui-textfield class="mt-3" iconStart="@tui.search">
    <input
      tuiInput
      [formControl]="searchInput"
      [placeholder]="t('Cherchez par nom, conversation ou ajoutez un email')"
      (keydown.enter)="submit()" />
  </tui-textfield>

  @let channels = channels$ | async;
  @let users = users$ | async;

  @let listItemClasses = 'cursor-pointer rounded-lg px-3 py-1.5 hover:bg-background-tertiary';

  <div class="my-3 flex min-h-52 w-full flex-col">
    @if (channels || users) {
      @if (channels?.length > 0 || users?.length > 0) {
        <div class="relative flex flex-col gap-3">
          @if (channels?.length > 0) {
            <ng-container *ngTemplateOutlet="title; context: { title: t('Conversations') }" />
            <div class="flex flex-col">
              @for (channel of channels; track channel.id) {
                <pxc-channel-preview
                  size="medium"
                  [channel]="channel"
                  [ngClass]="listItemClasses"
                  [showDetails]="false"
                  (click)="selectChannel(channel)" />
              }
            </div>
          }
          @if (users?.length > 0) {
            <ng-container *ngTemplateOutlet="title; context: { title: t('Utilisateurs') }" />
            <div class="flex flex-col">
              @for (user of users; track user.id) {
                <pxc-user-card size="medium" [ngClass]="listItemClasses" [user]="user" (click)="selectUser(user)" />
              }
            </div>
          }
        </div>
      } @else {
        <pxc-empty-state
          [icon]="searchInput.value.includes('@') ? '@tui.at-sign' : searchInput.value ? '@tui.search' : '@tui.meh'"
          [title]="
            searchInput.value.includes('@')
              ? t('Entrez un email et appuyez sur Entrée pour ajouter un utilisateur.')
              : searchInput.value
                ? t('Aucune conversation ou utilisateur ne correspond à votre recherche.')
                : t(
                    'Vous n\'avez pas encore de conversations ! Cherchez un utilisateur ou entrez un email pour démarrer.'
                  )
          " />
      }
    } @else {
      <pxc-loader />
    }
  </div>

  <ng-template #title let-title="title">
    <p class="sticky! top-0 z-10 bg-background-primary-alt py-1 text-text-tertiary">
      {{ title }}
    </p>
  </ng-template>
</ng-container>
